import styled from "styled-components";

const S = {
    PageWrapper: styled.div`
        background: #f8fafc;
        min-height: 100vh;
        padding-bottom: 80px;
    `,
    HeroSection: styled.section`
        background: linear-gradient(135deg, #00A9C4 0%, #00798c 100%);
        padding: 80px 20px;
        text-align: center;
        color: white;

        @media (max-width: 768px) {
            padding: 40px 16px;
        }

        .hero-content {
            max-width: 800px;
            margin: 0 auto;

            h1 {
                font-size: 3.5em;
                font-weight: 800;
                margin: 0 0 20px 0;
                letter-spacing: -1px;

                @media (max-width: 768px) {
                    font-size: 2.2em;
                }

                @media (max-width: 480px) {
                    font-size: 1.75em;
                }
            }
        }
    `,
    Breadcrumb: styled.div`
        display: flex;
        align-items: center;
        justify-content: center;
        flex-wrap: wrap;
        gap: 10px;
        font-size: 1.1em;
        opacity: 0.9;

        @media (max-width: 768px) {
            font-size: 0.95em;
            gap: 6px;
        }
        
        a, span {
            color: white;
            text-decoration: none;
            font-weight: 500;
            transition: opacity 0.2s ease;
            
            &:hover {
                opacity: 0.7;
            }
        }
        
        .separator {
            font-size: 0.9em;
            opacity: 0.6;
        }
    `,
    ContentWrapper: styled.div`
        max-width: 1000px;
        margin: -40px auto 0;
        padding: 0 20px;
        position: relative;
        z-index: 10;
        box-sizing: border-box;

        @media (max-width: 768px) {
            margin: -24px auto 0;
            padding: 0 12px;
        }
        
        .faq-container {
            background: white;
            border-radius: 24px;
            padding: 50px;
            box-shadow: 0 20px 40px rgba(0, 0, 0, 0.08);
            border: 1px solid rgba(0,0,0,0.04);
            margin-bottom: 40px;
            box-sizing: border-box;

            @media (max-width: 768px) {
                padding: 24px 14px;
                border-radius: 18px;
                margin-bottom: 24px;
            }

            .MuiAccordion-root {
                border-radius: 12px !important;
                margin-bottom: 15px;
                border: 1px solid rgba(0,0,0,0.05) !important;
                box-shadow: 0 4px 15px rgba(0,0,0,0.02) !important;
                overflow: hidden;

                &:before {
                    display: none;
                }

                &.Mui-expanded {
                    margin-bottom: 15px;
                    box-shadow: 0 10px 25px rgba(0, 169, 196, 0.1) !important;
                    border-color: rgba(0, 169, 196, 0.3) !important;
                }
            }

            .MuiAccordionSummary-root {
                background: #f8fafc !important;
                padding: 0 20px;

                @media (max-width: 768px) {
                    padding: 0 14px;
                }
                
                &.Mui-expanded {
                    background: #fff !important;
                    border-bottom: 1px solid rgba(0, 0, 0, 0.05);
                }

                .MuiTypography-root {
                    font-size: 1.1em;
                    font-weight: 600;
                    color: #1e293b;

                    @media (max-width: 768px) {
                        font-size: 1em;
                    }
                }
            }

            .MuiAccordionDetails-root {
                background: #fff;
                padding: 24px;
                color: #475569;
                font-size: 1.05em;
                line-height: 1.6;

                @media (max-width: 768px) {
                    padding: 16px 14px;
                    font-size: 0.95em;
                }

                ul {
                    padding-left: 20px;
                    margin: 0;

                    @media (max-width: 768px) {
                        padding-left: 16px;
                    }
                    
                    li {
                        margin-bottom: 8px;
                        &:last-child {
                            margin-bottom: 0;
                        }
                    }
                }
            }
        }
    `
};

export default S;